import { useEffect, useState } from "react";
import api from "../api";

const emptyForm = { title: "", body: "" };

const Newsletters = () => {
  const [list, setList] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const res = await api.get("/newsletters");
      setList(res.data || []);
    } catch (err) {
      console.error("Error loading newsletters", err);
      alert("Error loading newsletters");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.title.trim() || !form.body.trim()) {
      alert("Title and body are required");
      return;
    }
    setSaving(true);
    try {
      await api.post("/newsletters", {
        title: form.title.trim(),
        body: form.body.trim(),
      });
      setForm(emptyForm);
      await load();
    } catch (err) {
      console.error("Save error", err);
      alert("Error saving newsletter");
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this newsletter?")) return;
    try {
      await api.delete(`/newsletters/${id}`);
      await load();
    } catch (err) {
      console.error("Delete error", err);
      alert("Error deleting newsletter");
    }
  };

  const formatDate = (iso) => {
    if (!iso) return "-";
    const d = new Date(iso);
    return d.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <div className="newsletter-shell">
      <div className="newsletter-header">
        <div>
          <h1 className="newsletter-title">Newsletters</h1>
          <p className="newsletter-subtitle">
            Create and manage announcements shown on the employee dashboard.
          </p>
        </div>
      </div>

      <div className="newsletter-card">
        <div className="newsletter-form-head">
          <div>
            <h3>Add Newsletter</h3>
          </div>
        </div>
        <form className="filter-row" onSubmit={handleSubmit}>
          <div>
            <label className="filter-label">Title</label>
            <input
              className="filter-input"
              value={form.title}
              onChange={(e) => setForm((f) => ({ ...f, title: e.target.value }))}
              required
            />
          </div>
          <div style={{ gridColumn: "span 2" }}>
            <label className="filter-label">Body</label>
            <textarea
              className="filter-input"
              rows={3}
              value={form.body}
              onChange={(e) => setForm((f) => ({ ...f, body: e.target.value }))}
              required
            />
          </div>
          <div style={{ alignSelf: "flex-end" }}>
            <button className="btn btn-primary" type="submit" disabled={saving}>
              {saving ? "Saving..." : "Add Newsletter"}
            </button>
          </div>
        </form>

        {loading ? (
          <p>Loading...</p>
        ) : list.length === 0 ? (
          <p className="text-muted" style={{ marginTop: 10 }}>
            No newsletters yet.
          </p>
        ) : (
          <div className="newsletter-stack admin">
            {list.map((n) => (
              <div key={n.id} className="newsletter-card admin">
                <div className="newsletter-card-top">
                  <span className="newsletter-date-pill">
                    {formatDate(n.created_at)}
                  </span>
                </div>
                <h4 className="newsletter-title-rich">{n.title}</h4>
                <p className="newsletter-body-rich">{n.body}</p>
                <div className="newsletter-card-actions">
                  <button
                    className="btn btn-danger"
                    onClick={() => handleDelete(n.id)}
                    style={{ padding: "4px 10px" }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Newsletters;
